
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockEomProcessingDialog extends Serenity.EntityDialog<IcStockEomProcessingRow, any> {
        protected getFormKey() { return IcStockEomProcessingForm.formKey; }
        protected getIdProperty() { return IcStockEomProcessingRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockEomProcessingRow.localTextPrefix; }
        protected getNameProperty() { return IcStockEomProcessingRow.nameProperty; }
        protected getService() { return IcStockEomProcessingService.baseUrl; }
        protected getDeletePermission() { return IcStockEomProcessingRow.deletePermission; }
        protected getInsertPermission() { return IcStockEomProcessingRow.insertPermission; }
        protected getUpdatePermission() { return IcStockEomProcessingRow.updatePermission; }

        protected form = new IcStockEomProcessingForm(this.idPrefix);
        public fg: string;
        public ffg: number;
        constructor() {
            super();
            // this.form.IcFg.changeSelect2(e => {
            //     this.icfgp();
                // console.log(Q.toId(this.form.EndBillPmType.value))};
               
                
            }
        
            
        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close::after"), 1);

            
            let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "ผ่านรายการสต๊อก",
                    hint: "Post and Save",
                    separator: false,
                    cssClass: "button-save-post",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {
                        // var self = this;
                        // if (this.validateForm() && this.validateBeforeSave()) {
                        //     var options = this.getSaveOptions((response) => {

                        //         if (this.isEditMode()) {
                        //             var id1 = response.EntityId;
                        //             if (id1 == null) {
                        //                 id1 = this.get_entityId();
                        //             }
                        //             var a = this.loadById(id1);
                        //         }
                        //         else {
                        //             var a = this.loadById(response.EntityId);
                        //         }
                                
                                // this.showSaveSuccessMessage(response);
                                Q.confirm('ยืนยันการประมวลผล', () => {
                                    this.form.PostFg.value = "2";                                    
                                    // this.form.PostFg.forceUpdate();
                                    this.save((response1) => {
                                        this.dialogClose();
                                    });
                                });

                        //     });

                        //     options.onError = function (response) {
                        //         Q.alert(response.Error.Message);

                        //     }

                        //     Q.serviceCall(options);
                        // }




                    }
                };
                buttons.push(newSavePosBtn);

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            
            this.deleteButton.hide();
            this.saveAndCloseButton.hide();
            this.applyChangesButton.hide();

            this.ffg = IcParaRow.getLookup().itemById[1].PostSequenceFg;
            // console.log(IcParaRow.getLookup().itemById[1].PostSequenceFg)
            this.form.PostSequenceFg.value = this.ffg.toString()
            
            // this.cloneButton.hide();

        }

    }
}